module.exports = __webpack_public_path__ + "img/feeder.4c3fddce.png";